import PinField from 'react-pin-field';
import {InButtonLoading} from '../../../../../common/components/InButtonLoader';
import {useI18n} from '../../../../../common/providers/I18nProvider';
import SubmitButton from '../SubmitButton';
import {UseOTP} from './Types';
import useOTP from './useOTP';
import Form from '../Form';

export default function OTP(props: UseOTP) {
	const {otpLength, validate, loading, error, resend: resendWrapper} = useOTP(props);
	const {resend, isResending, canResend, seconds, showTimer} = resendWrapper;
	const {email} = props;
	const {i18n} = useI18n();

	return (
		<Form title='AUTH.OTP.TITLE' subtitle='AUTH.OTP.SUBTITLE' afterSubtitle={email} status={error}>
			<div className='mb-4 sm:mb-5 lg:mb-9 flex justify-center'>
				<PinField
					length={otpLength}
					onComplete={validate}
					validate='0123456789'
					inputMode='numeric'
					className='h-10 lg:h-14 w-10 lg:w-14 border mx-1.5 rounded-lg flex items-center text-center font-thin text-base lg:text-3xl border-[#CCC]'
				/>
			</div>

			<div className='mb-4 sm:mb-5 lg:mb-9 flex justify-between text-[#808080] font-normal'>
				<span className='text-sm md:text-base ml-0 sm:ml-4'>{i18n('AUTH.OTP.NOT_RECEIVED')}</span>
				{isResending && (
					<span className='text-primary text-sm font-medium text-center'>
						<InButtonLoading />
					</span>
				)}
				{canResend && (
					<button className='text-primary text-sm font-medium text-center' onClick={resend}>
						{i18n('AUTH.OTP.BUTTON.RESEND')}
					</button>
				)}
				{showTimer && (
					<span className='text-primary text-sm font-medium text-center pr-1'>
						{i18n('AUTH.OTP.RESEND_TIMER', {seconds})}
					</span>
				)}
			</div>

			<SubmitButton canNotSubmit loading={loading}>
				{i18n('AUTH.OTP.BUTTON.VERIFY')}
			</SubmitButton>
		</Form>
	);
}
